import { Pipe, PipeTransform } from '@angular/core';
import { IShipping } from '../interfaces/shipping.interface';
import { ShippingStatusEnum } from '../enums/shipping-status.enum';

@Pipe({
  name: 'shippingStatus',
})
export class ShippingStatusPipe implements PipeTransform {
  transform(value: IShipping, kind: 'icon' | 'literal') {
    switch (value.status) {
      case ShippingStatusEnum.DELIVERED:
        return kind === 'icon' ? 'task_alt' : 'Entrega Concluída';
      case ShippingStatusEnum.CANCELED:
        return kind === 'icon' ? 'close' : 'Entrega Cancelada';
      case ShippingStatusEnum.SEARCHING_CARRIER:
      case ShippingStatusEnum.COLLECTION_ROUTE:
      case ShippingStatusEnum.SHIPPING_ROUTE:
      default:
        return '';
    }
  }
}
